import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const departmentRoutes = [
  {
    path: '/departments',
    name: Routes.Departments,
    component: () => import('@/pages/contexts/portal/all-departments/Index.vue'),
    meta: {
      pageTitle: 'Manage Departments',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_DEPARTMENTS,
    },
  },
  {
    path: '/department/:departmentId',
    name: Routes.Department,
    component: () => import('@/pages/contexts/portal/department/Index.vue'),
    meta: {
      pageTitle: 'Manage Department',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_DEPARTMENT,
    },
    children: [
      {
        path: 'create-role',
        name: Routes.DepartmentCreateRole,
        component: () => import('@/pages/contexts/portal/department/roles/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_DEPARTMENT,
        },
      },
      {
        path: 'update-role/:roleId',
        name: Routes.DepartmentUpdateRole,
        component: () => import('@/pages/contexts/portal/department/roles/Update.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_DEPARTMENT,
        },
      },
      {
        path: 'create-shift-category',
        name: Routes.DepartmentCreateShiftCategory,
        component: () => import('@/pages/contexts/portal/department/shift-categories/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_DEPARTMENT,
        },
      },
      {
        path: 'update-shift-category/:shiftCategoryId',
        name: Routes.DepartmentUpdateShiftCategory,
        component: () => import('@/pages/contexts/portal/department/shift-categories/Update.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_DEPARTMENT,
        },
      },
      {
        path: 'create-shift-category-attribute',
        name: Routes.DepartmentCreateShiftCategoryAttribute,
        component: () => import('@/pages/contexts/portal/department/shift-category-attributes/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_DEPARTMENT,
        },
      },
      {
        path: 'update-shift-category-attribute/:shiftCategoryAttributeId',
        name: Routes.DepartmentUpdateShiftCategoryAttribute,
        component: () => import('@/pages/contexts/portal/department/shift-category-attributes/Update.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_DEPARTMENT,
        },
      },
    ],
  },
]
